import React from 'react';
import PropTypes from 'prop-types';
import { getState as getComponentPreloadState } from '../utils/preloadState';
import Slide from '../containers/Slide';
import SlideChaser from './SlideChaser/SlideChaser.jsx';

import './ScrollWrapper.css';

class ScrollWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = { slideDistance: [] };
    this.el = React.createRef();
    this.hasBeenShown = new Set();
  }

  static getDerivedStateFromProps(props, state) {
    state.slideDistance = props.slide_order.map(
      (id, i) => i - props.slideIndex
    );
    return state;
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.slide_order.length !== 0 ||
        this.props.slide_order.length === 0) &&
      !this.props.slideReferrer
    ) {
      return;
    }
    const targetSlide = this.el.current.children[this.props.slideIndex];

    if (targetSlide && document.scrollingElement) {
      document.scrollingElement.scrollTo(0, targetSlide.offsetTop);
    }
  }

  render() {
    if (!this.props.slide_order.length) {
      return this.renderContainer();
    }

    const slides = [];

    this.props.slide_order.forEach((id, i) => {
      const distance = Math.abs(i - this.props.slideIndex);
      const preloadState = getComponentPreloadState(distance);
      slides.push(
        <Slide
          id={id}
          key={id}
          distance={this.state.slideDistance[i]}
          preloadState={preloadState}
        />
      );
    });

    return this.renderContainer(
      <React.Fragment>
        {slides}
        <SlideChaser clientType={this.props.clientTypeId} />
      </React.Fragment>
    );
  }

  renderContainer(children) {
    return (
      <div className="ScrollWrapper" ref={this.el}>
        {children}
      </div>
    );
  }
}

ScrollWrapper.defaultProps = {
  slideReferrer: '',
  slideIndex: 0,
  slide_order: []
};

ScrollWrapper.propTypes = {
  slideReferrer: PropTypes.string,
  slideIndex: PropTypes.number,
  slide_order: PropTypes.array
};

export default ScrollWrapper;
